import { Fragment } from "react";
import Menu from "../../modules/public/menu/menu";
import Footer from "../../modules/public/footer/footer";
import usePage from "../../hooks/usePage";
import { Col, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { developersList } from "./DevelopersPage";
import style from "./DevelopersPage.module.css";
import WebServiceForm from "../webService/WebServiceForm";

const DevelopersItemPage = () => {
  const { pathname } = useLocation();
  const boxItem = developersList.find(item => item.url === pathname);

  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}

        <Container className="rtl-all my-6">
          <nav>
            <ul className="list-inline d-flex p-0 column-gap-2">
              <li>
                <Link to="/developers">توسعه دهندگان</Link>
              </li>
              <li> / </li>
              <li>
                <Link to={pathname}>{boxItem.title}</Link>
              </li>
            </ul>
          </nav>

          <div className=" col-12 col-sm-6 col-md-4 float-start mt-4 me-5 pb-2">
            <div className="light-shadow px-3 py-3 my-2 bg-body rounded card">
              <img
                src={boxItem.image}
                className={`w-100 rounded ${style.img}`}
                alt={boxItem.title}
              />

              <div className="d-flex flex-wrap mt-2">
                <div className="w-100 w-md-75 pb-2">{boxItem.title}</div>
                <Link
                  className="btn-success-style text-center rounded mt-4"
                  to={boxItem.downloadUrl}
                  target="_blank"
                >
                  دانلود
                </Link>
              </div>
            </div>
          </div>

          {pageText}

          {!!boxItem.videoUrl && (
            <Col xs={12} lg={8} className="mt-7 px-5 mx-auto">
              <video
                autoPlay
                width="100%"
                height="100%"
                src={boxItem.videoUrl}
                controls
              />
            </Col>
          )}

          {pageImage}
        </Container>

        <WebServiceForm />
      </main>

      <Footer />
    </Fragment>
  );
};

export default DevelopersItemPage;
